import clsx from 'clsx';
import React from 'react';
import UserIcon from '../../assets/icons/user-icon.svg?react';
import Input from '../Input';
import Button from '../Button';
import { useButtonSizeSmall } from '../../utils/buttonSizes';
import { FormikProps } from 'formik';

interface DeleteUserModalProps {
  otherClasses?: string;
  title: string;
  formHandler: FormikProps<{ name: string }>;
  handleClose: () => void;
}

const DeleteUserModal: React.FC<DeleteUserModalProps> = ({
  otherClasses,
  formHandler,
  handleClose,
  title,
}) => {
  const deleteUserModalClasses = clsx(otherClasses);

  return (
    <div className={deleteUserModalClasses} data-testid="delete-user-modal">
      <div className="mb-8 flex w-full flex-col items-center gap-2.5 text-center lg:mb-12">
        <UserIcon className="[&>path]:fill-brand-posh-pink h-12 w-12 md:h-85 md:w-85" />
        <h4 className="text-brand-posh-pink capitalize">Are you sure?</h4>
        <p className="font-inter-variable text-neutral-tones-text -tracking-text-area text-base leading-5 font-normal lg:text-lg">
          To continue deletion process, type the name{' '}
          <strong>“{title.trim().replace(/\s+/g, ' ')}”</strong> exactly into
          the text field below.
        </p>
        <p className="font-inter-variable text-neutral-tones-text -tracking-text-area mt-2 text-base leading-5 font-normal lg:text-lg">
          Please note that this action is irreversible.
        </p>
      </div>
      <form action="#" onSubmit={formHandler?.handleSubmit}>
        <div className="mt-2.5 grid grid-cols-1">
          <Input
            onBlur={formHandler?.handleBlur}
            label={`Type "${title.trim().replace(/\s+/g, ' ')}"`}
            errorMessage={
              formHandler?.touched.name && formHandler?.errors.name
                ? formHandler?.errors.name
                : ''
            }
            disabled={formHandler?.isSubmitting}
            value={formHandler?.values.name}
            type="text"
            placeholder="Write something here..."
            onChange={formHandler?.handleChange}
            name="name"
            otherClasses={{ container: 'w-full' }}
          />
        </div>
        <div className="mt-8 flex flex-col-reverse gap-15 md:grid md:grid-cols-2 md:gap-6 lg:mt-12">
          <Button
            variant="secondary"
            type="button"
            size={useButtonSizeSmall()}
            onClick={() => handleClose()}
            otherClasses="border-transparent text-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink"
          >
            Cancel
          </Button>
          <Button
            disable={
              formHandler?.values.name.trim().replace(/\s+/g, ' ') !==
                title.trim().replace(/\s+/g, ' ') || formHandler?.isSubmitting
            }
            type="submit"
            size={useButtonSizeSmall()}
            otherClasses="bg-brand-posh-pink hover:text-brand-posh-pink hover:border-brand-posh-pink"
          >
            Delete User
          </Button>
        </div>
      </form>
    </div>
  );
};

export default DeleteUserModal;
